module.exports = __webpack_public_path__ + "media/images/announceGroup__bg-0de950aeb1f46ddca9cf1159bebd7350.jpg";